<template>


    <div class="container mt-5">

        <router-link class="btn-back" to="/"><i class="fas fa-long-arrow-alt-left"></i> Retourner à la page d'accueil </router-link> <span class="ml-5 grey">{{ $t('translation') }}</span>

        <div class="titleProduct"><img src="../assets/img/NovaCollecte.png" class="img-fluid logoProd" alt="DigitAppro">NovaCollecte</div>
        <div class="subTitle">Sécurisez votre collecte grâce à la signature électronique et la cotation temps réel pour vos <strong>clients</strong>, vos <strong>TC</strong> et votre <strong>mise en marché</strong>.</div>
       


        <div class="highlighted"> 
            <i class="fas fa-solid fa-shield-alt blue"></i>
            Protégez vous de la volatilité des marchés
        </div>
        <div class="row align-items-center pb-5">
            <div class="col-md-6">
                <p class="card-title">La volatilité des prix sur le marché des matières premières a considérablement renforcé le risque de litige lié aux mauvaises contractualisations.</p>
                
                <div class="card-title mt-5">
                    <i class="fas fa-solid fa-signature green mr-3"></i> Signature électronique probante
                </div>
                <p>Avec <strong>NovaCollecte</strong> assurez une contractualisation incontestable signée électroniquement par vos clients / adhérents.</p>
                <p>La signature électronique a une valeur légale et peut être réalisée sur ordinateur, tablette ou smartphone.</p>
                
                <div class="card-title mt-5">
                    <i class="fas fa-solid fa-chart-line green mr-3"></i> Connexion MATIF temps réel
                </div>
                <p>La valeur EURONEXT temps réel est utilisée lors de la signature du contrat, permettant ainsi du supprimer le risque lié à la volatilité.</p>
                <p>Vos clients/adhérents pourront voir la valeur instantanée à laquelle ils signent leurs engagements. L'ensemble de ses engagements seront visibles dans l'historique de son compte.</p>

            </div>
            <div class="col image"  data-aos="zoom-in-left"  data-aos-duration="1000"><img src="../assets/img/novacollecte/signMob.png" class="img-fluid screenShot profiledRight" alt="DigitAppro"></div>
        </div>

        <div class="row align-items-center mt-5">
            <div class="col image"  data-aos="zoom-in-right"  data-aos-duration="1000"><img src="../assets/img/novacollecte/boNC.png" class="img-fluid screenShot profiledLeft" alt="DigitAppro"></div>
            <div class="col-md-6">
                <div class="card-title">
                    <i class="fas fa-tachometer-alt green mr-3"></i>Remontée rapide des contrats pour votre mise en marché
                </div>
                <p>Réduisez le délai entre la signature d'un contrat et la remonté de l'information à votre équipe de mise en marché.</p>
                <p><strong>Moins de délai réduit considérablement le risque lié à la volatilité des prix.</strong></p>
                <div class="card-title mt-5">
                    <i class="fas fa-user-cog green mr-3"></i> Gardez le contrôle sur votre offre de collecte
                </div>
                <p>Fixez vos limites par espèce, par jour et gérer l'ouverture / fermeture de vos cotation automatiquement et manuellement.</p>
                <p>Configurez la marge de négociation disponible pour vos TCs.</p>
                <p>Modifiez vos majorations, primes, marge ou tout autre élément de prix et ils seront <strong>instantanément répercutés</strong> sur les offres clients/adhérents </p>
            </div>
        </div>

        


        <div class="highlighted"> 
            <i class="fas fa-solid fa-tractor blue"></i>
            Pour vos agriculteurs
        </div>

        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="card-title">
                    Une "bourse aux céréales" ergonomique et efficace
                </div>
                <p><strong>NovaCollecte</strong> permet à vos clients / adhérents de trouver en un coup d'oeil les offres qui les intéressent. Qu'ils soient utilisateurs d'un OAD ou sur recommandation de leur technicien, ils pourront rapidement et sereinement vendre leur récolte.</p>
                <div class="card-title mt-5">
                    Engagement, suivi des livraisons et des échantillons au même endroit
                </div>
                <p>De la consultation des offres, la signature des contrats de vente, le suivi des livraisons, des échantillons et des contrats filières, <strong>NovaCollecte</strong> regroupe toute l'activité de collecte de votre client / adhérent au même endroit. </p>
            </div>
            <div class="col image" data-aos="zoom-in-left"  data-aos-duration="1000" ><img src="../assets/img/novacollecte/homeMobNC.png" class="img-fluid screenShot profiledRight" alt="DigitAppro" ></div>
        </div>

        <div class="row align-items-center mt-5">
            <div class="col image" data-aos="zoom-in-right"  data-aos-duration="1000" ><img src="../assets/img/novacollecte/contractNC.png" class="img-fluid screenShot profiledLeft" alt="DigitAppro" ></div>

            <div class="col-md-6">
                <div class="card-title">
                    Information temps réel, détaillée et complète : pour une mailleure autonomie
                </div>
                <p>Consultation en ligne de l'offre collecte par espèce, période, récolte en temps réel du marché et avec toutes les options logistiques.</p>
                <p>Choix des adresses de départ, enlèvement en ferme ou livraison silo : toute votre offre de collecte lisible et fiable pour vos agriculteurs.</p>
            </div>
        </div>

        <div class="row align-items-center mt-5">
            <div class="col-md-6">
                <div class="card-title">
                    Site internet et application mobile en marque blanche
                </div>
                <p>Offrez un accès <strong>multi-canal</strong> à vos agriculteurs avec le même niveau de service et d'ergonomie.</p>
                <p>Renforcez le lien avec vos clients / adhérents graçe à notre offre en marque blanche et valorisez <strong>votre identité de marque</strong> avec un outil innovant.</p>
            </div>
            <div class="col image" data-aos="zoom-in-left"  data-aos-duration="1000" ><img src="../assets/img/novacollecte/devicesNC.png" class="img-fluid  profiledRight" alt="DigitAppro" ></div>
        </div>




        <div class="highlighted"> 
            <i class="fas fa-solid fa-user-tie blue"></i>
            Pour vos techniciens
        </div>

        <div class="row align-items-center">
            <div class="col-md-6">
                <div class="card-title">
                    Accélérez votre force de vente
                </div>
                <p>Vos TC pourront saisir en quelques clics des contrats qu'ils enverront à leurs clients via un lien email ou SMS.</p>
                <p>Le client pourra consulter et signer électroniquement l'offre de son TC en quelques secondes.</p>
                <div class="card-title">
                    Pilotez l'activité de vos TC
                </div>
                <p>Suivez en temps réel le nombre de contrats envoyés, signés pour piloter au plus proche de vos besoins votre force de vente.</p>
                <p>Configurez la marge de négociation que vous octroyez à vos TC par espèce ou par contrat depuis votre console d'administration.</p>
            </div>
            <div class="col image" data-aos="zoom-in-left"  data-aos-duration="1000" ><img src="../assets/img/novacollecte/tcNC.png" class="img-fluid screenShot profiledRight" alt="DigitAppro" ></div>
        </div>





        



        


<!--         
        
        <div class="highlighted mt-5"> Nos clients témoignent </div>

       
        <div class="row">

            <div class="col-sm-6 mx-auto">
                <div class="card">
                    <div class="mr-auto mb-3"><img class="img-fluid" src="@/assets/img/seveal.png" alt=""></div>
                    <div class="temoignage">
                        « Nous avons fait appel à AgriVitech pour développer la stratégie digitale des associés de SeVeal concernant le réapprovisionnement des intrants agricoles. <br>
                        Outre les précieuses recommandations qui nous ont été apportées, nous avons beaucoup apprécié la finesse de l’approche, la co-construction, le maquettage permettant de se projeter, et l’expérience client mise au centre du projet nous permettant de rester pertinents et logiques.
                        Ce fut une expérience très riche et agréable pour nous tous. <br>
                        Un grand merci à cette équipe jeune, dynamique et pleine de talents ! »
                    </div>
                    <div class="client"><span class="clientName">Emmanuel J.</span>, DG SEVEAL UNION</div>
                </div>
            </div>
                
        </div> -->
            


        

        

        <!-- <div class="container">
            <div class="contact-block text-center m-5">
            <div class="block_title">Compte Démo : Connectez-vous</div>
            <div class="imgContact">
                <div class="form-group">
                    <label class="formLabel"  for="login">Email/login</label>
                    <input  v-model="login" required  type="email" class="form-control" id="txtlogin" aria-describedby="login">
                </div>
                <div class="form-group">
                    <label class="formLabel" for="mdp">Mot de passe</label>
                    <input  v-model="mdp"  type="password" class="form-control" id="txtmdp" aria-describedby="mdp">
                </div>
                <button v-on:click="toDap()" class="form-group btn btn-secondary">Se connecter</button>
                <div class="result" v-bind:class="{ 'text-danger': hasError }">{{ result }}</div>
            </div>
            <router-link class="btn btn-primary mx-auto" to="/contact-demo">Demander un accès </router-link>
            </div>    
        </div> -->



        <div class="highlighted text-center"> Ils utilisent la solution NovaFerme </div>
            <div class="row clients-logo text-center mb-5">
            <!-- <div class="col-lg-4 logoContainer mx-auto"><img class="img-fluid" src="@/assets/img/vivescia.png" alt=""></div>
            <div class="col-lg-4 logoContainer mx-auto"><img class="img-fluid" src="@/assets/img/ceresia.png" alt=""></div>
            <div class="col-lg-4 logoContainer mx-auto"><img class="img-fluid" src="@/assets/img/logo_novagrain.svg" alt=""></div>
            <div class="col-lg-4 logoContainer mx-auto"><img class="img-fluid" src="@/assets/img/seveal.png" alt=""></div> -->
            <div class="col-lg-4 logoContainer mx-auto"><img class="img-fluid" src="@/assets/img/logo-sepac-compagri.jpg" alt=""></div>
        </div>



        <MailjetNewsLetter/>

    </div>


    
    
</template>

<script>

import MailjetNewsLetter from '../components/MailjetNewsLetter'


export default {
    name: 'NovaCollecte',
    data(){
      return {
        login: '',
        mdp:'',
        hasError:false,
        result:'',
        img0: true,
        img1: false
      }
    },    
    components:{
            MailjetNewsLetter
        },
    methods:{
         toDap () {
            this.hasError = false
            this.result = ''
            if (!this.login || this.login.trim() === '' || this.mdp.trim() === '' || !this.mdp) {
              this.hasError = true
              this.result = 'Merci de renseigner tous les champs afin de vous connecter'
            } else {
              const jeton = window.btoa(unescape(encodeURIComponent("loginTiers="+this.login+"&password=" + this.mdp)));
              const uri = "https://staging-front.digitappro.io/login?jetonsso="+jeton;
              const encoded = encodeURI(uri);
              window.open(encoded, '_blank');
            }
         }
    }
}
</script>

<style lang="scss" scoped>

  

    .highlighted{
        font-size: 40px!important;
        font-weight: 800;
        margin-top: 140px;
        margin-bottom: 50px;
        display: flex;
        flex-direction: column;
        align-items: center;
        color: var(--mainBlue)!important;
        .blue{
           color: var(--mainGreen);
           font-size: 30px!important;
        }

    }

    p{
        text-align: justify;
    }

    @media (min-width: 768px) {

        .profiledRight{
        // transform: translate(20%, 0px) rotate(-4e-05deg) rotateY(-5deg) rotateX(4deg)!important;
        transform: translate(20%, 0px)!important;
        }
        .profiledLeft{
            // transform: translate(-20%, 0px) rotate(-4e-05deg) rotateY(5deg) rotateX(4deg)!important;
            transform: translate(-20%, 0px) !important;
        }
        .large{
            // transform: translate(-40%, 400px) rotate(-4e-05deg) rotateY(14deg) rotateX(10deg) scale(1.5)!important;
        }
            
    }
    @media (max-width: 768px) {

        .profiledRight{
            margin-top: 50px;
        }   
        .profiledLeft{
            margin-bottom: 50px;
        }
        .image{
            padding: 0px 30px;
        }
            
    }



    

    .decoIcon{
        position: relative;
        height: 20px;
        width: 20px;
        transform: rotate(90deg);
    }

    .titleProduct{
        text-align: left;
        font-weight: 600;
        font-size: 55px;
        color: var(--mainBlue);
        padding-top: 50px;
    }

    .screenShot{
        -webkit-box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
        box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
        border-radius: 20px;
    }

    .featuresList{
        text-align: center;
        font-size: 20px;
        font-weight: 600;
        img{
            padding: 5px;
            margin-bottom: 40px;
        }
    }

    video{
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        -webkit-box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
        box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
        width: 100%;
        margin-top: 50px;
        margin-bottom: 50px;
        &:hover{
            cursor:auto;
        }
    }

    .poductLink{
        background-color: white;
        border: var(--mainBlue) 10px solid;
        border-radius: 20px;
        padding: 30px;
        text-align: center;
    }

     .btn {
        padding: 15px;
        font-weight: 600;
        margin: 20px;
        min-width: 200px;
    }

    .contact-block {
        color: white;
        font-weight: 600;
        font-size: 25px;
        background-color: var(--mainBlue);
        padding: 20px;
        border-radius: 18px;
        text-align: center;
    .tagline{
      padding: 50px 0px 20px 0px;
    }
    .styledInput{
        margin: auto;
        border-radius: 25px;
        max-width: 300px;
        height: 45px;
    }
    .button-input{
        background-color: var(--mainGreen);
        color: white;
        position: relative;
        height: 40px;
        top: -42.5px;
        left: 105px;
        z-index: 20;
        &:hover{
            background-color: var(--mainBlue);
        }
    }
    .form-group{
    
      .formLabel{
          font-size: 16px;
          font-weight: 600;
      }
      .form-text{
          font-size: 13px;
          font-weight: 400;
      }
    }
    
    .block_title {
      color: var(--mainGreen);
      text-align: left;
    }

    
    
    .result {
        font-weight: 600;
        margin-top: 10px;
        color: var(--mainGreen);
    }
    // .imgContact{
    //     background-image: url('../assets/img/contactezNous.png');
    //     background-repeat: no-repeat;
    //     background-position: center;
    //     background-size: cover;
    //     height: 20%;
    // }
  }
  .logoProd {
        max-height: 120px;
    }

    .card {
        border: none;
        border-radius: 10px;
        padding: 15px;
        margin-bottom: 15px;
        -webkit-box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
        box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
        // height: 200px;
        .temoignage{
            font-style: italic;
        }
        .client{
            margin-top: 15px;
            font-size: 13px;
            .clientName{
                font-weight: 600;
                color: var(--mainGreen);
            }
        }
    }
    .card-title{
            font-weight: 700;
            font-size: 16px;
            svg{
                font-size: 25px;
            }
        }
        .icon-title{
            width:40px; 
            height: 40px;
        }


    .chart-btn{
        display: flex;
        align-items: stretch;
        justify-content: space-between;
        .card{
            width: 24%;
            &:hover{
                cursor: pointer;
                background-color: var(--mainGreen);
            }
            ul{
                margin-block-start: 0px;
                padding-inline-start: 15px;
            }
        }
    }


</style>